namespace Matrix.DataAudit {
    export namespace AccountHistoryService {
        export const baseUrl = 'DataAudit/AccountHistory';

        export declare function Create(request: Serenity.SaveRequest<AccountHistoryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<AccountHistoryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<AccountHistoryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: AccountHistoryListRequest, onSuccess?: (response: Serenity.ListResponse<AccountHistoryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetDateMatch(request: AccountHistoryGetDateMatchRequest, onSuccess?: (response: Serenity.RetrieveResponse<AccountHistoryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "DataAudit/AccountHistory/Create",
            Update = "DataAudit/AccountHistory/Update",
            Delete = "DataAudit/AccountHistory/Delete",
            Retrieve = "DataAudit/AccountHistory/Retrieve",
            List = "DataAudit/AccountHistory/List",
            GetDateMatch = "DataAudit/AccountHistory/GetDateMatch"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetDateMatch'
        ].forEach(x => {
            (<any>AccountHistoryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
